import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReportingApiService } from './service/reporting-api.service';

@NgModule({
  imports: [CommonModule],
  providers: [ReportingApiService],
})
export class ReportingApiModule {}
